import { useQuery } from "react-query";

import { getTranslations, Translations } from "@/api";
import { getUseQueryLocalStorage, setUseQueryLocalStorage } from "@/utils";

const key = "translations";

export const useTranslations = (props: {
  language: string;
  refetchOnMount?: "always" | boolean;
  enabled?: boolean;
}) => {
  const { language, refetchOnMount, enabled } = props;
  const { data, ...query } = useQuery(
    ["translations"],
    () => {
      return getTranslations(language);
    },
    {
      onSuccess: (data) => {
        setUseQueryLocalStorage(key, data);
      },
      initialData: () => {
        return (getUseQueryLocalStorage(key) as Translations) ?? undefined;
      },
      refetchOnMount,
      enabled,
    },
  );

  return { ...query, translations: data };
};
